import { Theme } from "@mui/material";

const yourServiceWorldStyle = {
  container: (theme: Theme) => ({
    backgroundColor: theme.palette.background.light,
    height: "100%",
    padding: "2rem",
    textAlign: "left",
  }),
  chip: {
    marginBottom: "1rem",
  },
  image: { width: "100%", height: "auto" },
  imageContainer: {
    marginTop: "4rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default yourServiceWorldStyle;
